import React from "react";
import classNames from "classnames";

import Field from "../../atoms/field/Field.jsx";
import Button from "../button/ButtonController.jsx";
import { useIntl, FormattedMessage } from "react-intl";

export default function ChangePassword(props) {
  const {
    className,
    data,
    errors,
    onChange,
    onButtonClick,
    loading,
    slim,
    ...rest
  } = props;
  const { message } = errors;
  const buttonDisabled = loading || !!message;
  const intl = useIntl();

  return (
    <div className={classNames("change-password", className)}>
      {message && <div className="field__error">{message}</div>}
      {!slim && (
        <Field
          label={intl.formatMessage({ id: "oldPswd" })}
          type="password"
          name="oldpassword"
          data={data}
          errors={errors}
          onChange={onChange}
        />
      )}
      <Field
        label={intl.formatMessage({ id: "newPswd" })}
        type="password"
        name="password"
        data={data}
        errors={errors}
        onChange={onChange}
      />
      <Field
        label={intl.formatMessage({ id: "confirmNewPswd" })}
        type="password"
        name="repassword"
        data={data}
        errors={errors}
        onChange={onChange}
      />
      <div className="paragraph" style={{ marginBottom: 10 }}>
        <FormattedMessage id="passwordRequirement" />
      </div>
      <Button
        className="change-password__button"
        onClick={onButtonClick}
        disabled={buttonDisabled}
      >
        <FormattedMessage id="confirmChanges" />
      </Button>
    </div>
  );
}
